import { catchError, EMPTY, from, mergeMap } from "rxjs"
import { ACTION_TYPES } from "../actions/types"
import { ofType } from "redux-observable"
import { Service } from "../services/service"
import { Action } from "../actions/actions"
import { Proposal } from "../models"
import { StockDocumentAction } from "../../inventory/stockdocument/actions"

export const fetchEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.FETCH),
        mergeMap(({payload}) => {
            return from(Service.get(payload)).pipe(
                mergeMap(res  => {
                    const doc = res as Proposal
                    return [
                        Action.fetchSuccess(doc),
                    ]
                }),
                catchError(() => EMPTY)
            )
        })
    )
}

export const sendByEmailEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.SEND_BY_EMAIL),
        mergeMap(({payload}) => {
            return from(Service.sendByEmail(payload.proposalHash, payload)).pipe(
                mergeMap(res  => {
                    const doc = res as Proposal
                    return [
                        Action.fetchSuccess(doc),
                        StockDocumentAction.reload()
                    ]
                }),
                catchError(() => EMPTY)
            )
        })
    )
}



// WEBPACK FOOTER //
// ./src/state/proposal/epics/epics.ts